
import { defineComponent } from 'vue'
import { isExternal } from '@/utils/validator'
import { useRouter } from 'vue-router'
export default defineComponent({
    props: {
        to: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const router = useRouter()
        const push = () => {
            router.push(props.to).catch((err) => {
            })
        }
        return {
            push,
            isExternal
        }
    }
})
